@if (sideNavVisible) {
  <div class="position-relative h-100">
    <aside
      aria-label="navigation"
      class="sidenav-container d-flex flex-coloumn justify-content-between h-100"
    >
      <ul>
        <li
          (click)="navigate(companyItem, null)"
          (keydown)="handleKeydown($event, companyItem)"
          [ngClass]="{ active: isActive('/company-information') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 11H17.8C18.9201 11 19.4802 11 19.908 11.218C20.2843 11.4097 20.5903 11.7157 20.782 12.092C21 12.5198 21 13.0799 21 14.2V21M13 21V6.2C13 5.0799 13 4.51984 12.782 4.09202C12.5903 3.71569 12.2843 3.40973 11.908 3.21799C11.4802 3 10.9201 3 9.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V21M22 21H2M6.5 7H9.5M6.5 11H9.5M6.5 15H9.5"
              stroke="#4E4E4E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">Company Information</span>
        </li>
        <li
          (click)="navigate(OperatingAuthorityItem, null)"
          (keydown)="handleKeydown($event, OperatingAuthorityItem)"
          [ngClass]="{ active: isActive('/OperatingAuthorities') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.18577 19.3913V5.09179C4.18577 4.00956 4.18577 3.46845 4.44425 3.05509C4.67162 2.69149 5.03442 2.39588 5.48066 2.21062C5.98796 2 6.65205 2 7.98024 2H12.249C13.5772 2 14.2413 2 14.7486 2.21062C15.1948 2.39588 15.5576 2.69149 15.785 3.05509C16.0435 3.46845 16 3.91773 16 5V12M4.18577 19.3913H8.55027M4.18577 19.3913H3M8.33597 5.86473H10.8933M8.33597 9.72947H10.8933M8.33597 13.5942H10.8933M12.3913 18.8207H13.9565M10.8261 16.6196L11.8696 17.1087L12.5325 15.2442C12.6693 14.8593 12.7378 14.6669 12.8647 14.5246C12.9767 14.399 13.1207 14.3017 13.2832 14.2418C13.4673 14.1739 13.6837 14.1739 14.1164 14.1739H17.9706C18.4033 14.1739 18.6196 14.1739 18.8037 14.2418C18.9663 14.3017 19.1102 14.399 19.2223 14.5246C19.3492 14.6669 19.4176 14.8593 19.5544 15.2442L20.2174 17.1087L21.2609 16.6196M18.1304 18.8207H19.6957M13.3304 17.1087H18.7565C19.6331 17.1087 20.0714 17.1087 20.4062 17.2686C20.7008 17.4093 20.9402 17.6338 21.0903 17.9099C21.2609 18.2238 21.2609 18.6347 21.2609 19.4565V20.7772C21.2609 21.0045 21.2609 21.1181 21.2408 21.2126C21.1585 21.6007 20.8349 21.904 20.421 21.9812C20.3202 22 20.199 22 19.9565 22H19.6957C19.1194 22 18.6522 21.562 18.6522 21.0217C18.6522 20.8867 18.5354 20.7772 18.3913 20.7772H13.6957C13.5516 20.7772 13.4348 20.8867 13.4348 21.0217C13.4348 21.562 12.9676 22 12.3913 22H12.1304C11.888 22 11.7668 22 11.666 21.9812C11.2521 21.904 10.9285 21.6007 10.8461 21.2126C10.8261 21.1181 10.8261 21.0045 10.8261 20.7772V19.4565C10.8261 18.6347 10.8261 18.2238 10.9967 17.9099C11.1467 17.6338 11.3862 17.4093 11.6807 17.2686C12.0155 17.1087 12.4538 17.1087 13.3304 17.1087Z"
              stroke="#374151"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">DFW Operating Authority</span>
        </li>
        <li
          (click)="navigate(OperatingAuthorityApplicationItem, null)"
          (keydown)="handleKeydown($event, OperatingAuthorityApplicationItem)"
          [ngClass]="{ active: isActive('/OperatingAuthorityApplication') }"
          tabindex="0"
          [matTooltip]="'OA Applications'"
          [matTooltipPosition]="'right'"
          [matTooltipDisabled]="!isTextTruncated(labelEl)"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.18577 19.3913V5.09179C4.18577 4.00956 4.18577 3.46845 4.44425 3.05509C4.67162 2.69149 5.03442 2.39588 5.48066 2.21062C5.98796 2 6.65205 2 7.98024 2H12.249C13.5772 2 14.2413 2 14.7486 2.21062C15.1948 2.39588 15.5576 2.69149 15.785 3.05509C16.0435 3.46845 16 3.91773 16 5V12M4.18577 19.3913H8.55027M4.18577 19.3913H3M8.33597 5.86473H10.8933M8.33597 9.72947H10.8933M8.33597 13.5942H10.8933M12.3913 18.8207H13.9565M10.8261 16.6196L11.8696 17.1087L12.5325 15.2442C12.6693 14.8593 12.7378 14.6669 12.8647 14.5246C12.9767 14.399 13.1207 14.3017 13.2832 14.2418C13.4673 14.1739 13.6837 14.1739 14.1164 14.1739H17.9706C18.4033 14.1739 18.6196 14.1739 18.8037 14.2418C18.9663 14.3017 19.1102 14.399 19.2223 14.5246C19.3492 14.6669 19.4176 14.8593 19.5544 15.2442L20.2174 17.1087L21.2609 16.6196M18.1304 18.8207H19.6957M13.3304 17.1087H18.7565C19.6331 17.1087 20.0714 17.1087 20.4062 17.2686C20.7008 17.4093 20.9402 17.6338 21.0903 17.9099C21.2609 18.2238 21.2609 18.6347 21.2609 19.4565V20.7772C21.2609 21.0045 21.2609 21.1181 21.2408 21.2126C21.1585 21.6007 20.8349 21.904 20.421 21.9812C20.3202 22 20.199 22 19.9565 22H19.6957C19.1194 22 18.6522 21.562 18.6522 21.0217C18.6522 20.8867 18.5354 20.7772 18.3913 20.7772H13.6957C13.5516 20.7772 13.4348 20.8867 13.4348 21.0217C13.4348 21.562 12.9676 22 12.3913 22H12.1304C11.888 22 11.7668 22 11.666 21.9812C11.2521 21.904 10.9285 21.6007 10.8461 21.2126C10.8261 21.1181 10.8261 21.0045 10.8261 20.7772V19.4565C10.8261 18.6347 10.8261 18.2238 10.9967 17.9099C11.1467 17.6338 11.3862 17.4093 11.6807 17.2686C12.0155 17.1087 12.4538 17.1087 13.3304 17.1087Z"
              stroke="#374151"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2 nav-label" #labelEl> OA Applications </span>
        </li>
      </ul>

      <ul class="nav-bottom">
        <li
          (click)="navigate(notificationsItem, null)"
          (keydown)="handleKeydown($event, notificationsItem)"
          [ngClass]="{ active: isActive('/notifications') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5Z"
              stroke="#111827"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">Notifications</span>
          @if (unreadNotifications > 0) {
            <span class="notification-badge">{{
              unreadNotifications > 99 ? '99+' : unreadNotifications
            }}</span>
          }
        </li>
        <li
          (click)="navigate(commentsItem, null)"
          (keydown)="handleKeydown($event, commentsItem)"
          [ngClass]="{ active: isActive('/comments') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17M10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C15.1484 5.54303 16.1274 6.38833 16.8321 7.4453C17.5367 8.50227 17.9404 9.73107 18 11V14C18.0753 14.6217 18.2954 15.2171 18.6428 15.7381C18.9902 16.2592 19.4551 16.6914 20 17H4C4.54494 16.6914 5.00981 16.2592 5.35719 15.7381C5.70457 15.2171 5.92474 14.6217 6 14V11C6.05956 9.73107 6.4633 8.50227 7.16795 7.4453C7.8726 6.38833 8.85159 5.54303 10 5Z"
              stroke="#111827"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">Comments</span>
          @if (unreadComments > 0) {
            <span class="notification-badge">{{
              unreadComments > 99 ? '99+' : unreadComments
            }}</span>
          }
        </li>
        <li
          (click)="navigate(helpItem, null)"
          (keydown)="handleKeydown($event, helpItem)"
          [ngClass]="{ active: isActive('/help') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 16.45H11.992M9.33333 10.2222C9.33333 9.69481 9.48973 9.17923 9.78275 8.7407C10.0758 8.30217 10.4922 7.96038 10.9795 7.75854C11.4668 7.55671 12.003 7.5039 12.5202 7.6068C13.0375 7.70969 13.5127 7.96367 13.8856 8.33661C14.2586 8.70955 14.5125 9.1847 14.6154 9.70198C14.7183 10.2193 14.6655 10.7554 14.4637 11.2427C14.2618 11.73 13.9201 12.1465 13.4815 12.4395C13.043 12.7325 12.5274 12.8889 12 12.8889V13.7778M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
              stroke="#111827"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">Help & Support</span>
        </li>
        <li
          (click)="navigate(downloadItem, null)"
          (keydown)="handleKeydown($event, downloadItem)"
          [ngClass]="{ active: isActive('/download-documents') }"
          tabindex="0"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
              stroke="#111827"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="ms-2">Download Documents</span>
        </li>
      </ul>
    </aside>
  </div>
}
